export default __webpack_public_path__ + "25dc964bdc5a05e7bd39811d539ba950.png";